module.exports = __webpack_public_path__ + "minimal_logo-41f1d32484e6b0f87f3e305fd82544e5.svg";